export const state = () => ({
  selectMember: {},
  Result:'',
  editMember:{},
})